<form autocomplete="off" *ngIf="pnrForm && (validatedPnrData$ | async) === null">
  <h3 class="font-heading-2 ms-small-y">
    {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.title' | finLocalization }}
  </h3>
  <span class="font-body-1 block">
    {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.enterDetails' | finLocalization }}
  </span>

  <fcom-text-input
    class="ms-small-y block"
    [parentForm]="pnrForm"
    [controlName]="'lastName'"
    [translationPrefix]="'loginFields.lastName'"
    [translationErrorPrefix]="'loginFields.lastName.validationMessages'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.lastNamePlaceholder'"
  >
  </fcom-text-input>

  <fcom-text-input
    class="ms-small-t block"
    [parentForm]="pnrForm"
    [controlName]="'bookingRef'"
    [translationPrefix]="'loginFields.recLoc'"
    [translationErrorPrefix]="
      'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.bookingReference.validationMessages'
    "
    [placeHolder]="'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.bookingReference.placeholder'"
    [displayMargin]="false"
  >
  </fcom-text-input>

  <span class="block ms-large-y">
    {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.or' | finLocalization }}
  </span>

  <fcom-text-input
    class="ms-small-y block"
    [parentForm]="pnrForm"
    [controlName]="'eTicket'"
    [translationPrefix]="'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.eTicket'"
    [translationErrorPrefix]="'SERVICE_FORMS.serviceForms.fields.ticketNumber'"
    [placeHolder]="'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.eTicket.placeholder'"
    [visualDisable]="true"
  >
  </fcom-text-input>

  <div class="flex flex--end border-top ps-large-t">
    <fcom-button
      [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
      [text]="'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.search' | finLocalization"
      [loading]="formStatus === FormStatus.LOADING"
      [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
      [icon]="loadingIcon"
      (clickBtn)="checkPnr()"
    ></fcom-button>
  </div>

  <fcom-notification *ngIf="pnrNotFound$ | async" class="mr-medium-y" [theme]="NotificationTheme.ALERT">
    {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.notFound' | finLocalization }}
  </fcom-notification>
  <fcom-notification *ngIf="formStatus === FormStatus.ERROR" class="mr-medium-y" [theme]="NotificationTheme.ALERT">
    {{ 'errors.generic.title' | finLocalization }}
  </fcom-notification>
</form>
<form autocomplete="off" *ngIf="contactDetailsForm && (validatedPnrData$ | async) !== null">
  <div *ngIf="validatedPnrData$ | async as validatedPnrData">
    <h3 class="font-heading-2 ms-small-y">
      {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.title' | finLocalization }}
    </h3>
    <span class="block font-body-1 regular-type nordic-blue-400-text">
      {{ 'loginFields.lastName.label' | finLocalization }}
    </span>
    <span class="block font-body-1 medium-type">{{ validatedPnrData.lastName }}</span>

    <span class="block font-body-1 regular-type nordic-blue-400-text ms-small-t">
      {{
        (validatedPnrData.pnr
          ? 'loginFields.recLoc.label'
          : 'SERVICE_FORMS.serviceForms.vatReceiptForm.bookingInformation.eTicket.label'
        ) | finLocalization
      }}
    </span>
    <span class="block font-body-1 medium-type">{{ validatedPnrData.pnr || validatedPnrData.ticketNumber }}</span>
  </div>

  <ng-container *ngIf="(showCompanyDetailsForm$ | async) === true">
    <div class="ms-medium-y">
      <fin-form-input-checkbox
        [parentForm]="contactDetailsForm"
        [controlName]="'addCompanyDetails'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.addCompanyDetails'"
      ></fin-form-input-checkbox>
    </div>

    <ng-container *ngIf="contactDetailsForm.get('addCompanyDetails').value">
      <h3 class="font-heading-2 ms-small-y">
        {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.title' | finLocalization }}
      </h3>
      <span class="font-body-1">
        {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.includedInformation' | finLocalization }}
      </span>
      <fcom-notification *ngIf="(profile$ | async) === null">
        <cms-unstyled-fragment
          class="font-body-1 unstyled-fragment-line-height"
          [contentUrl$]="
            'SERVICE_FORMS.fragments.vatReceiptForm.loginNotification.url' | finLocalization | finToObservable
          "
        >
        </cms-unstyled-fragment>
      </fcom-notification>

      <span class="block pr-medium-b font-body-1">
        {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.mandatoryFields' | finLocalization }}
      </span>

      <fcom-text-input
        [parentForm]="contactDetailsForm"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.companyName'"
        [controlName]="'companyName'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.companyName.placeholder'"
      ></fcom-text-input>

      <fcom-text-input
        [parentForm]="contactDetailsForm"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.businessId'"
        [controlName]="'businessId'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.businessId.placeholder'"
      ></fcom-text-input>

      <fcom-text-input
        [parentForm]="contactDetailsForm"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.address'"
        [controlName]="'address'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.address.placeholder'"
      ></fcom-text-input>

      <div class="flex">
        <div class="flex-1 ps-xsmall-r">
          <fcom-text-input
            [parentForm]="contactDetailsForm"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.postalCode'"
            [controlName]="'postalCode'"
            [placeHolder]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.postalCode.placeholder'"
          ></fcom-text-input>
        </div>
        <div class="flex-1">
          <fcom-text-input
            [parentForm]="contactDetailsForm"
            [translationPrefix]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.city'"
            [controlName]="'city'"
            [placeHolder]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.city.placeholder'"
          ></fcom-text-input>
        </div>
      </div>

      <fin-select-input
        [parentForm]="contactDetailsForm"
        [controlName]="'country'"
        [options]="countries$ | async"
        [selectLabelTranslationKey]="
          'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.country.placeholder'
        "
        [translationPrefix]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.country'"
      ></fin-select-input>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="(showCompanyDetailsForm$ | async) !== true">
    <div *ngIf="profile$ | async as profile" class="ms-large-t">
      <div class="ms-large-b">
        <h3 class="font-heading-2 ms-small-y">
          {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.title' | finLocalization }}
        </h3>
        <span class="font-body-1">
          {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.includedInformation' | finLocalization }}
        </span>
      </div>

      <div class="ms-small-b" data-testid="vat-receipt-contact-details-panel">
        <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
          {{ 'SERVICE_FORMS.serviceForms.corporateContactForm.contactDetails.companyName.label' | finLocalization }}
        </span>
        <span class="font-body-1 bold-type block">{{ profile.corporate?.name }}</span>
      </div>

      <div class="ms-small-b">
        <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
          {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.businessId.label' | finLocalization }}
        </span>
        <span class="font-body-1 bold-type block">{{ profile.corporate?.businessId }}</span>
      </div>

      <div class="ms-small-b">
        <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
          {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.address.label' | finLocalization }}
        </span>
        <span class="font-body-1 bold-type block">{{ profile.corporate?.street }}</span>
      </div>

      <div class="ms-small-b">
        <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
          {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.postalCode.label' | finLocalization }}
        </span>
        <span class="font-body-1 bold-type block">{{ profile.corporate?.zipcode }}</span>
      </div>

      <div class="ms-small-b">
        <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
          {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.city.label' | finLocalization }}
        </span>
        <span class="font-body-1 bold-type block">{{ profile.corporate?.city }}</span>
      </div>

      <div class="ms-small-b">
        <span class="font-body-1 ms-xxsmall-b nordic-blue-400-text block">
          {{ 'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.fields.country.label' | finLocalization }}
        </span>
        <span class="font-body-1 bold-type block">{{ profile.corporate?.country }}</span>
      </div>
    </div>
  </ng-container>

  <div class="border-top ps-large-t flex flex--end">
    <fcom-button
      class="ps-small-r"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [text]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.startOver' | finLocalization"
      [loading]="formStatus === FormStatus.LOADING"
      [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
      (clickBtn)="startOver()"
    ></fcom-button>

    <fcom-button
      (clickBtn)="downloadReceipt()"
      [text]="'SERVICE_FORMS.serviceForms.vatReceiptForm.companyDetails.download' | finLocalization"
      [loading]="formStatus === FormStatus.LOADING"
      [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
      [icon]="{ name: SvgLibraryIcon.EXTERNAL_TAB, position: IconPosition.RIGHT }"
    ></fcom-button>
  </div>
</form>
